'use client';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';

export default function HomeFooter() {
  const pathname = usePathname();
  const router = useRouter();

  const handleScrollTo = (e, id) => {
    e.preventDefault();

    // If we're already on the homepage, scroll smoothly
    if (pathname === '/') {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        window.history.replaceState(null, '', `#${id}`);
      }
    } else {
      // If on another page, go to homepage then scroll
      router.push(`/#${id}`);
    }
  };
  return (
    <footer className="home-footer">

      {/* =====================================================
          MAIN FOOTER
          ===================================================== */}
      <div className="footer-main">

        {/* LOGO */}
        <div className="footer-brand">
          <Link href="/" className="footer-logo-link">
            <Image
              src="/images/AVE-Payroll.png"
              alt="Avetium Payroll"
              width={240}
              height={55}
              className="footer-logo"
            />
          </Link>
        </div>

        {/* PLATFORM */}
        <div className="footer-column">
          <h3>Platform</h3>

          <Link href="/about">
            About
          </Link>

          <a href="#features" onClick={(e) => handleScrollTo(e, 'features')}>
            Features
          </a>

          <Link href="pricing/pricing-and-subscription">
            Pricing &amp; Plans
          </Link>

          <Link href="/contact">
            Contact
          </Link>
        </div>

        {/* RESOURCES */}
        <div className="footer-column">
          <h3>Resources</h3>

          {/* <Link href="/account">
            Account
          </Link> */}

          {/* <Link href="/tools">
            Tools
          </Link> */}

          <Link href="https://avetiumtechnologies.com">
            Blog
          </Link>

          <Link href="/faq">
            FAQ
          </Link>
        </div>

        {/* PRODUCTS */}
        <div className="footer-column">
          <h3>Products</h3>

          <Link href="/contact">
            Request a Demo
          </Link>

          <Link href="/auth/register">
            Create account
          </Link>

          {/* <Link href="/feedback">
            Share feedback
          </Link> */}

          {/* <Link href="/help">
            Helpdesk
          </Link> */}
        </div>

        {/* LEGALS */}
        <div className="footer-column">
          <h3>Legals</h3>

          {/* <Link href="/guides">
            Guides
          </Link> */}

          <Link href="/terms-of-use">
            Terms &amp; Conditions
          </Link>

          <Link href="/privacy">
            Privacy Policy
          </Link>

          {/* <Link href="/licensing">
            Licensing
          </Link> */}
        </div>

      </div>

      {/* =====================================================
          DIVIDER
          ===================================================== */}
      <div className="footer-divider" />

      {/* =====================================================
          FOOTER BOTTOM
          ===================================================== */}
      <div className="footer-bottom">

        {/* PRODUCT */}
        <div className="footer-product">
          <span>A product of</span>

          <span className="footer-avetium">
            ▲ AVETIUM
          </span>
        </div>

        {/* =================================================
            CENTER FOOTER INFORMATION
            ================================================= */}
        <div className="footer-center">

          <p className="footer-tagline">
            Trusted by growing teams across two markets, backed
            by an engineering team with almost a decade of
            enterprise delivery.
          </p>

          <p className="footer-copyright">
            © 2026, All Rights Reserved
          </p>

        </div>

        {/* SOCIALS */}
        <div className="footer-socials">

          <Link
            href="#"
            aria-label="Instagram"
            className="footer-social"
          >
            <i className="bi bi-instagram" />
          </Link>

          <Link
            href="#"
            aria-label="WhatsApp"
            className="footer-social"
          >
            <i className="bi bi-whatsapp" />
          </Link>

          <Link
            href="#"
            aria-label="Facebook"
            className="footer-social"
          >
            <i className="bi bi-facebook" />
          </Link>

          <Link
            href="#"
            aria-label="LinkedIn"
            className="footer-social"
          >
            <i className="bi bi-linkedin" />
          </Link>

        </div>

      </div>

    </footer>
  );
}
